'use client';

import { Link } from '@/i18n/routing';
import { Article } from '@/types';
import ArticleItem from '@/components/common/ArticleItem';
import useDynamicTranslation from '@/hooks/useDynamicTranslation';
import { useLocale } from 'next-intl';

interface ArticlesClientProps {
  list: Article[];
}

export default function ArticlesClient({ list }: ArticlesClientProps) {
  const { dt } = useDynamicTranslation();
  const locale = useLocale();

  return (
    <div className="page-wrapper" dir={locale === 'ar' ? 'rtl' : 'ltr'}>
      <ul className="ps-breadcrumb">
        <li className="ps-breadcrumb__item">
          <Link href="/">{dt('home')}</Link>
        </li>
        <li className="ps-breadcrumb__item active" aria-current="page">
          {dt('blogs')}
        </li>
      </ul>
      <div className="list-container">
        {list?.map((article) => (
          <ArticleItem key={article.id} article={article} />
        ))}
      </div>

      <style jsx>{`
        .page-wrapper {
          padding: 40px 20px;
          max-width: 1500px;
          margin: 0 auto;
        }

        .list-container {
          display: grid;
          grid-template-columns: 1fr;
          gap: 30px;
        }

        @media (min-width: 768px) {
          .list-container {
            grid-template-columns: 1fr 1fr;
          }
        }

        @media (min-width: 1024px) {
          .list-container {
            grid-template-columns: 1fr 1fr 1fr;
          }
        }

        @media (min-width: 1280px) {
          .list-container {
            grid-template-columns: 1fr 1fr 1fr 1fr;
          }
        }
      `}</style>
    </div>
  );
}
